import { WEB_3D_TOURS_EXPERIMENT } from '../../constants/experiments';
import { IAbUseExperiment } from '../../types/abUseExperiments';

export const is3DToursExperimentActive = (experiments: IAbUseExperiment[]): boolean => {
  const experiment = experiments.find(e => e.experimentName === WEB_3D_TOURS_EXPERIMENT);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === 'B';
};
